"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RememberedAccountsContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _uiKit = require("@cian/ui-kit");
var React = _interopRequireWildcard(require("react"));
var _RememberedAccountItem = require("../../components/RememberedAccountItem");
var _RememberedAccountsLayout = require("../../components/RememberedAccountsLayout");
var _rememberedAccounts = require("../../types/rememberedAccounts");
var _flow = require("../../types/flow");
var _rememberedAccounts2 = require("../../utils/rememberedAccounts");
var _formatPhone = require("../../utils/formatPhone");
var _validation = require("../../utils/validation");
var _state = require("../../actions/state");
var _authentication = require("../../actions/authentication");
var _flow2 = require("../../actions/flow");
var _tracking = require("./tracking");
var _TitleContainer = require("../TitleContainer");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const RememberedAccountsContainer = _ref => {
  let {
    useDispatch,
    source
  } = _ref;
  const [accounts, setAccounts] = React.useState([]);
  const dispatch = useDispatch();
  const switchFlow = React.useCallback(() => {
    dispatch((0, _state.resetToPhoneAuth)());
  }, [dispatch]);
  React.useEffect(() => {
    const accounts = (0, _rememberedAccounts2.getRememberedAccounts)();
    if (accounts.length === 0) {
      switchFlow();
    } else {
      (0, _tracking.trackRememberedAccountsOpen)(source);
    }
    setAccounts(accounts);
  }, []);
  const handleAccountClick = React.useCallback((type, value, index) => {
    if (type === _rememberedAccounts.ERememberedAccountType.Phone) {
      const phone = (0, _formatPhone.formatPhone)(value);
      dispatch((0, _state.changeToPhoneAuth)(phone));
    }
    if (type === _rememberedAccounts.ERememberedAccountType.Email) {
      dispatch((0, _state.changeToUsernameAuth)(value));
      if ((0, _validation.isEmail)(value)) {
        dispatch((0, _authentication.checkEmail)());
      } else {
        dispatch((0, _flow2.changeFlow)(_flow.EActiveFlow.Authentication));
      }
    }
    (0, _tracking.trackSelectRememberedAccount)(index, source);
  }, [dispatch, source]);
  const handleAccountDelete = React.useCallback((type, value, index) => {
    const accounts = (0, _rememberedAccounts2.deleteRememberedAccount)({
      type,
      value
    });
    setAccounts(accounts);
    (0, _tracking.trackDeleteRememberedAccount)(index, source);
    if (accounts.length === 0) {
      switchFlow();
    }
  }, [switchFlow, source]);
  const handleEnterOtherAccount = React.useCallback(() => {
    switchFlow();
    (0, _tracking.trackEnterOtherAccount)(source);
  }, [switchFlow, source]);
  const visibleAccounts = React.useMemo(() => accounts.slice(0, 3), [accounts]);
  return /*#__PURE__*/React.createElement(_RememberedAccountsLayout.RememberedAccountsLayout, {
    title: /*#__PURE__*/React.createElement(_TitleContainer.TitleContainer, {
      indent: "M"
    }),
    content: visibleAccounts.map((item, i) => /*#__PURE__*/React.createElement(_RememberedAccountItem.RememberedAccountItem, (0, _extends2.default)({
      key: item.value,
      index: i
    }, item, {
      onClick: handleAccountClick,
      onDelete: handleAccountDelete
    }))),
    controls: /*#__PURE__*/React.createElement(_uiKit.Button, {
      "data-name": "AnotherAccountBtn",
      key: "exit",
      type: "button",
      theme: "fill_secondary",
      fullWidth: true,
      onClick: handleEnterOtherAccount,
      size: "L"
    }, "\u0412\u043E\u0439\u0442\u0438 \u0432 \u0434\u0440\u0443\u0433\u043E\u0439 \u0430\u043A\u043A\u0430\u0443\u043D\u0442")
  });
};
exports.RememberedAccountsContainer = RememberedAccountsContainer;